import React, {createContext} from 'react';
import axios from 'axios';

export const ClientContext = createContext();
var apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

class ClientContextProvider extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            client: [],
            pips: [],
            message: {},
        };

    }

    componentDidMount(){
        this.readData();
        this.readClient();
    }

    //read
    readData() {
        axios.get(apiUrl+'/client/pips',{
            withCredentials:true
        })
            .then(response => {

                let pipData = response.data;
                for(var i in pipData){
                    if(pipData[i].dateOnMarket !== undefined){
                        var from = Date.parse(pipData[i].dateOnMarket);
                        var to = new Date();
                        var diff = (to-from)/(1000 * 3600 * 24);
                        pipData[i].daysOnMarket = diff;
                    }
                    else{
                        pipData[i].daysOnMarket = '';
                    }
                }

                this.setState({
                    pips: pipData,
                });
            }).catch(error => {
            console.error(error);
        });
    }

    readClient() {
        axios.get(apiUrl+'/client',{
            withCredentials:true
        })
            .then(response => {
                this.setState({
                    client: response.data,
                });
                
            }).catch(error => {
            console.error(error);
        });
    }


    outputDate(str){
        if(str !== undefined){
            return (new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "long",
                day: "2-digit"
            }).format(new Date(str)));
        }
        else{
            return '';
        }
    }

    outputCurrency(str){
        return  (new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })).format(str);
    }


    render() {
        return (
            <ClientContext.Provider value={{
                ...this.state,
                outputDate: this.outputDate.bind(this),
                outputCurrency: this.outputCurrency.bind(this),
                setMessage: (message) => this.setState({message: message}),
            }}>
                {this.props.children}
            </ClientContext.Provider>
        );
    }
}

export default ClientContextProvider;